/* tslint:disable */
/* eslint-disable */
/**
 * Muze REST API
 * API Data backend for Muze
 *
 * The version of the OpenAPI document: 1.6.0
 * Contact: dash@muze.nyc
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FFChat
 */
export interface FFChat {
    /**
     * 
     * @type {number}
     * @memberof FFChat
     */
    readonly id: number;
    /**
     * 
     * @type {string}
     * @memberof FFChat
     */
    readonly uuid: string;
    /**
     * 
     * @type {string}
     * @memberof FFChat
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof FFChat
     */
    isIndividualChat?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FFChat
     */
    readonly creator: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof FFChat
     */
    members: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof FFChat
     */
    readonly width: number;
    /**
     * 
     * @type {number}
     * @memberof FFChat
     */
    readonly height: number;
    /**
     * 
     * @type {string}
     * @memberof FFChat
     */
    readonly profileImageUuid: string;
    /**
     * 
     * @type {string}
     * @memberof FFChat
     */
    profileImageSmall?: string;
    /**
     * 
     * @type {string}
     * @memberof FFChat
     */
    profileImageLarge?: string;
    /**
     * 
     * @type {Date}
     * @memberof FFChat
     */
    readonly created: Date;
    /**
     * 
     * @type {Date}
     * @memberof FFChat
     */
    readonly modified: Date;
    /**
     * 
     * @type {Date}
     * @memberof FFChat
     */
    readonly lastActivity: Date;
    /**
     * 
     * @type {Date}
     * @memberof FFChat
     */
    readonly lastOpened: Date;
    /**
     * 
     * @type {string}
     * @memberof FFChat
     */
    readonly latestObject: string;
    /**
     * 
     * @type {string}
     * @memberof FFChat
     */
    membershipCreationRule?: string;
    /**
     * 
     * @type {string}
     * @memberof FFChat
     */
    readonly shareUrl: string;
    /**
     * 
     * @type {string}
     * @memberof FFChat
     */
    readonly viewUrl: string;
    /**
     * 
     * @type {string}
     * @memberof FFChat
     */
    visibility?: string;
}

export function FFChatFromJSON(json: any): FFChat {
    return FFChatFromJSONTyped(json, false);
}

export function FFChatFromJSONTyped(json: any, ignoreDiscriminator: boolean): FFChat {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'uuid': json['uuid'],
        'name': json['name'],
        'isIndividualChat': !exists(json, 'is_individual_chat') ? undefined : json['is_individual_chat'],
        'creator': json['creator'],
        'members': json['members'],
        'width': json['width'],
        'height': json['height'],
        'profileImageUuid': json['profile_image_uuid'],
        'profileImageSmall': !exists(json, 'profile_image_small') ? undefined : json['profile_image_small'],
        'profileImageLarge': !exists(json, 'profile_image_large') ? undefined : json['profile_image_large'],
        'created': (new Date(json['created'])),
        'modified': (new Date(json['modified'])),
        'lastActivity': (new Date(json['last_activity'])),
        'lastOpened': (new Date(json['last_opened'])),
        'latestObject': json['latest_object'],
        'membershipCreationRule': !exists(json, 'membership_creation_rule') ? undefined : json['membership_creation_rule'],
        'shareUrl': json['share_url'],
        'viewUrl': json['view_url'],
        'visibility': !exists(json, 'visibility') ? undefined : json['visibility'],
    };
}

export function FFChatToJSON(value?: FFChat | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'is_individual_chat': value.isIndividualChat,
        'members': value.members,
        'profile_image_small': value.profileImageSmall,
        'profile_image_large': value.profileImageLarge,
        'membership_creation_rule': value.membershipCreationRule,
        'visibility': value.visibility,
    };
}


